import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-string-formatter",
  imports: [TranslocoDirective],
  template: `
    <div class="flex items-center gap-2 truncate" *transloco="let t">
      @let label = firstLabel();
      @if (label !== undefined) {
        @let translationKey = translationKeys()?.[label];
        <div class="truncate">{{ translationKey ? t(translationKey) : label }}</div>
      }
      @if (values().length > 1) {
        <span class="text-gray-400">(+{{ values().length - 1 }})</span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringFormatterComponent<T> {
  readonly values = input.required<T[]>();
  readonly labelField = input<keyof T & string>();
  readonly translationKeys = input<Record<string, string>>();

  protected readonly firstLabel = computed(() => {
    if (this.values().length === 0) return undefined;
    const value = this.values()[0];
    const labelField = this.labelField();
    return String((labelField ? value[labelField] : value) ?? "");
  });
}
